module.exports = __webpack_public_path__ + "static/media/spinner-card.801ac015.png";